export default function FeaturedPick() {
  return (
    <section className="w-full bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 rounded-lg overflow-hidden border border-background-200 bg-background-50">
          <div className="w-full h-56 md:h-72 lg:h-full bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Painterly%20anime%20style%20illustration%20of%20a%20lone%20traveler%20with%20a%20lantern%20walking%20along%20a%20winding%20mountain%20path%20at%20dusk%2C%20warm%20amber%20and%20cream%20golden%20palette%2C%20soft%20brush%20texture%2C%20no%20text%2C%20cinematic%20decorative%20background&width=1200&height=800&seq=anime-feature-91&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="p-6 md:p-8 flex flex-col justify-center">
            <span className="inline-flex w-fit items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-900">
              <i className="ri-award-line" />
              编辑特别推荐
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
              如果只挑一部慢慢看，我们推荐《葬送的芙莉莲》
            </h2>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              它不靠密集的冲突撑场，而是把时间拉长，让观众跟着主角走过一段又一段旅途。
              每一次告别、每一段短暂的同行，都在悄悄回答「记忆为什么会留下」这个问题。
              适合在安静的夜晚连着看两三话，也适合作为进入奇幻题材的第一部作品。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["节奏舒缓", "情绪克制", "世界观完整", "适合入坑"].map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 rounded-md text-[11px] bg-secondary-100 text-secondary-900"
                >
                  {tag}
                </span>
              ))}
            </div>
            <a
              href="#ranking"
              className="mt-6 inline-flex w-fit items-center gap-2 h-10 px-4 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line" />
              回到排行榜查看详情
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}